'use client';
import { JoinButton } from './JoinButton';
import { SigninButton } from './SigninButton';
import { SignupButton } from './SignupButton';

export function AuthButtonsLoggedOut() {
  return (
    <>
      <SigninButton />
      <JoinButton />
      <SignupButton />
    </>
  );
}
